import { useSelector } from 'react-redux'
import { rootScopeSelector } from '../../selectors/scope'

const useRootScope = () => {
	return useSelector(rootScopeSelector);
};

export default useRootScope
